module.exports = __webpack_public_path__ + "img/Balkon02.bc2bcbec.jpg";